module.exports = __webpack_public_path__ + "static/media/fullLogoWhit.f71f689c.svg";